import React, { useState } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import { useDispatch, useSelector } from "react-redux";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { CreateCustomerApi, EditCustomerApi } from "../../ApiRequests";
import AuthBtn from "../Buttons/AuthBtn";
import { fetchCustomers } from "../../store/Slices/CustomerSlice";

const EditCustomerModal = ({ Open, setOpen, currentCustomer }) => {
  const [Name, setName] = useState(currentCustomer ? currentCustomer.name : "");
  const [Contact, setContact] = useState(
    currentCustomer ? currentCustomer.contact : ""
  );
  const [Contact2, setContact2] = useState(
    currentCustomer ? currentCustomer.contact2 || "" : ""
  );
  const [Address, setAddress] = useState(
    currentCustomer ? currentCustomer.address : ""
  );
  const [Email, setEmail] = useState(
    currentCustomer ? currentCustomer.email : ""
  );
  const [Ref, setRef] = useState(currentCustomer ? currentCustomer.ref : "");
  const [Page, setPage] = useState(
    currentCustomer ? currentCustomer.page_no : ""
  );
  const [Type, setType] = useState(
    currentCustomer ? currentCustomer.type.toString() : ""
  );
  const [password, setPassword] = useState("");
  const [Loading, setLoading] = useState(false);

  const handleTypeChange = (event) => {
    setType(event.target.value);
  };

  const dispatch = useDispatch();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (Name === "") {
      WarningToast("Enter a valid name");
    } else if (Contact === "") {
      WarningToast("Enter a valid contact number");
    } else if (Address === "") {
      WarningToast("Enter a valid address");
    } else {
      try {
        const response = await EditCustomerApi(currentCustomer._id, {
          name: Name,
          contact: Contact,
          contact2: Contact2,
          address: Address,
          email: Email,
          type: Type,
          ref: Ref,
          page: Page,
          password,
        });
        if (response.data.success) {
          setOpen(false);
          SuccessToast("Customer Updated successfully");
          dispatch(fetchCustomers());
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        console.log(err);
        ErrorToast("Failed to Update customer");
      }
    }
    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Update Customer
        </h1>
        <div className="flex flex-col px-10 gap-y-4">
          <div className="flex gap-x-1 items-center mx-auto">
            <div className="flex gap-x-1">
              <input
                type="radio"
                id="customer"
                name="type"
                value={"1"}
                checked={Type === "1"}
                onChange={handleTypeChange}
              />
              <label htmlFor="customer">Customer</label>
            </div>
            <div className="flex gap-x-1">
              <input
                type="radio"
                id="shop"
                name="type"
                value={"2"}
                checked={Type === "2"}
                onChange={handleTypeChange}
              />
              <label htmlFor="shop">Shop</label>
            </div>
          </div>
          <AuthInput
            label="Name"
            placeholder="Enter Name"
            Value={Name}
            setValue={setName}
          />
          <AuthInput
            label="Contact"
            placeholder="Enter Contact"
            Value={Contact}
            setValue={setContact}
          />
          <AuthInput
            label="Contact 2"
            placeholder="Enter second contact (optional)"
            Value={Contact2}
            setValue={setContact2}
          />
          <AuthInput
            label="Address"
            placeholder="Enter Address"
            Value={Address}
            setValue={setAddress}
          />
          <AuthInput
            label="Ref"
            placeholder="Enter Ref"
            Value={Ref}
            setValue={setRef}
          />
          <AuthInput
            label="Page"
            placeholder="Enter Page"
            Value={Page}
            setValue={setPage}
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {Loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Update Customer"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default EditCustomerModal;
